const GET_MEMBER_MESSAGELIST_REQUEST = 'GET_MEMBER_MESSAGELIST_REQUEST';
const GET_MEMBER_MESSAGELIST_SUCCESS = 'GET_MEMBER_MESSAGELIST_SUCCESS';
const GET_MEMBER_MESSAGELIST_FAILURE = 'GET_MEMBER_MESSAGELIST_FAILURE';

const ACTION_FILTER_MEMBER_MESSAGE_REQUEST = 'ACTION_FILTER_MEMBER_MESSAGE_REQUEST';
const ACTION_FILTER_MEMBER_MESSAGE_SUCCESS = 'ACTION_FILTER_MEMBER_MESSAGE_SUCCESS';
const ACTION_FILTER_MEMBER_MESSAGE_FAILURE = 'ACTION_FILTER_MEMBER_MESSAGE_FAILURE';

const CLEAR_MEMBER_MESSAGELIST_IN_MEMORY_SUCCESS = 'CLEAR_MEMBER_MESSAGELIST_IN_MEMORY_SUCCESS';

const initState = {
    newCount: 0,
    totalCount: 0,
    trashCount: 0,
    recipient: null,
    messageList: null,
};

import * as backend from 'backend-helpers/memberMessageList';

export default function memberMessageList(state = initState, action) {

    if (action.type === GET_MEMBER_MESSAGELIST_SUCCESS) {
        let {
            offset,
            messageList
        } = action.result.data.data;

        const { trash } = action.data;

        messageList = state.trash === trash && offset > state.offset ? [...state.messageList, ...messageList] : messageList;

        return {
            ...state,
            ...action.result.data.data,
            messageList,
            trash
        }
    }

    if (action.type === ACTION_FILTER_MEMBER_MESSAGE_SUCCESS) {
        let {
            newCount,
            totalCount,
            trashCount,
            messageList
        } = action.result.data;

        const actionFilter = action.data.action;
        const inDialogue = action.data.inDialogue;

        if(!inDialogue) {

            if(actionFilter === 'delete' && !messageList.length) {
                const { ids } = action.data;

                messageList = ids.map(i => { return {conversation_id: i} });
            }

            const conversationIds = messageList.map((item, i) => {
                const index = state.messageList.findIndex(i => i.conversation_id === item.conversation_id);

                if(index > -1){
                    actionFilter === 'read' ? state.messageList.splice(index, 1, item) : state.messageList.splice(index, 1);
                }
            });
        }

        return {
            ...state,
            newCount,
            totalCount,
            trashCount
        }
    }

    if (action.type === CLEAR_MEMBER_MESSAGELIST_IN_MEMORY_SUCCESS) {
        state = initState;
    }

    return state;
}

export function getMemberMessageList(data) {
    return {
        types: [GET_MEMBER_MESSAGELIST_REQUEST, GET_MEMBER_MESSAGELIST_SUCCESS, GET_MEMBER_MESSAGELIST_FAILURE],
        promise: backend.getMemberMessageList(data),
        data
    }
}

export function actionFilterMemberMessage(data) {
    return {
        types: [ACTION_FILTER_MEMBER_MESSAGE_REQUEST, ACTION_FILTER_MEMBER_MESSAGE_SUCCESS, ACTION_FILTER_MEMBER_MESSAGE_FAILURE],
        promise: backend.actionFilterMemberMessage(data),
        data
    }
}

export function clearMessageListInMemory(data) {
    return {
        type: CLEAR_MEMBER_MESSAGELIST_IN_MEMORY_SUCCESS
    }
}


// WEBPACK FOOTER //
// ./src/reducers/memberMessageList.js